import * as tslib_1 from "tslib";
import { Exclude, Type } from 'class-transformer';
import { DimensionOptionCodeRawDto } from '../../../../shared-cirabooks-module/_models/common/dimensions/dimension-option-code-raw-dto';
import { GLSubcategorySelectorResultDto } from '../../common/gl-account/glsubcategory-selector-result-dto';
const ɵ0 = () => DimensionOptionCodeRawDto, ɵ1 = () => GLSubcategorySelectorResultDto;
export class BaseAPBillItemRawDto {
    constructor() {
        this.crudAction = '';
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Array)
], BaseAPBillItemRawDto.prototype, "dimensions", void 0);
tslib_1.__decorate([
    Exclude(),
    Type(ɵ1),
    tslib_1.__metadata("design:type", Array)
], BaseAPBillItemRawDto.prototype, "subCategorySource", void 0);
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", Number)
], BaseAPBillItemRawDto.prototype, "itemId", void 0);
export { ɵ0, ɵ1 };
